<template>
  <div>
    <Navbar 
      @controlaSidebar="controlaSidebar"
    />
    <div class="container-fluid">
      <div class="row">
        <!-- Sidebar para desktop - versão corrigida -->
        <div class="col-lg-2 d-none d-lg-block bg-body-tertiary text-white min-vh-100 sticky-top border-end">
          <div class="d-flex flex-column flex-shrink-0 pt-3">
            <Sidebar />
          </div>
        </div>

        <div class="offcanvas offcanvas-start" style="max-width: 65%; min-width: 250px;" tabindex="-1" id="sidebaroffcanva" ref="offcanvasElement">
          <div class="text-center p-2 mt-4 border-bottom mb-3">
            <img src="@/assets/logo-cor.png" alt="Logo" width="150px" class="img-fluid mb-3" />
          </div>
          <Sidebar />
        </div>

        <!-- Conteúdo Principal -->
        <main class="col-lg-10 lc3-text-color pt-2" style="overflow :auto; height: calc(100vh - 57px);">
          <slot></slot>
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import Sidebar from '@/components/Sidebar.vue';
import { Offcanvas } from 'bootstrap';

export default {
  name: "PainelLayout",
  components: { Navbar, Sidebar },
  data() {
    return {
      offcanvasInstance: null
    }
  },
  mounted() {
    // Inicializar o offcanvas
    this.initializeOffcanvas();
  },
  methods: {
    initializeOffcanvas() {
      const element = this.$refs.offcanvasElement;
      this.offcanvasInstance = new Offcanvas(element);
      
      // Adicionar event listeners se necessário
      element.addEventListener('hidden.bs.offcanvas', this.onOffcanvasHidden);
      element.addEventListener('shown.bs.offcanvas', this.onOffcanvasShown);
    },
    
    controlaSidebar(acao) {
      if (!this.offcanvasInstance) return;
      
      switch(acao) {
        case "toggle":
          this.offcanvasInstance.toggle();
          break;
        case "open":
          this.offcanvasInstance.show();
          break;
        case "close":
          this.offcanvasInstance.hide();
          break;
      }
    },
    
    onOffcanvasHidden() {
      console.log('Offcanvas fechado');
      // Ações quando fechar
    },
    
    onOffcanvasShown() {
      console.log('Offcanvas aberto');
      // Ações quando abrir
    }
  },
  beforeUnmount() {
    // Limpar quando o componente for destruído
    if (this.offcanvasInstance) {
      this.offcanvasInstance.dispose();
    }
  }
};
</script>

<style scoped>
/* Estilos mínimos e seguros */
.min-vh-100 {
  min-height: calc(100vh - 57px) !important; /* Ajuste para considerar a altura da navbar */
}

.lc3-navbar-custom {
  background-color: var(--lc3-primary); /* Cor de fundo escura */
}

.lc3-text-color {
  color: var(--lc3-text-color);
}
</style>